import { Col } from 'antd'
import styled from 'styled-components'

const StyledLabelLegendsMatchTypeContainer = styled(Col)`
  color: #cccecf;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export default StyledLabelLegendsMatchTypeContainer
